import * as yup from 'yup';

export const addTaxFormSchema = yup.object().shape({
  taxDescription: yup.string().required(),
  applicableOrderTypes: yup
    .array()
    .min(1)
    .of(yup.string().required())
    .default([])
    .required(),
  taxType: yup.string().oneOf(['AMOUNT', 'PERCENTAGE']).default('AMOUNT'),
  amount: yup
    .number()
    .flexDefault(0)
    .when('taxType', {
      is: val => val === 'AMOUNT',
      then: schema => schema.required(),
    }),
  percentage: yup
    .number()
    .flexDefault(0)
    .max(100)
    .min(0)
    .when('taxType', {
      is: val => val === 'PERCENTAGE',
      then: schema => schema.required(),
    }),
  extTaxId: yup.string().nullable().default(''),
  enabledTaxRules: yup.boolean().default(false),
  rules: yup.array().of(
    yup.object({
      amount: yup.number().required().flexDefault(0),
      operator: yup.string().required().default(''),
    }),
  ),
});
